export interface CoverageTopic {
  id: string;
  label: string;
  chapterId: string;
  /** If true, show a sensitive-content gate before related prompts */
  sensitive?: boolean;
}

export const STEP1_COVERAGE_TOPICS: CoverageTopic[] = [
  { id: 'introduction', label: 'Introduction (name, fellowship)', chapterId: 'ch1' },
  { id: 'family_origin', label: 'Family of origin', chapterId: 'ch2' },
  { id: 'childhood_sexuality', label: 'Childhood sexuality / early experiences', chapterId: 'ch2', sensitive: true },
  { id: 'addiction_development', label: 'How addiction developed', chapterId: 'ch3' },
  { id: 'acting_out_patterns', label: 'Acting-out patterns', chapterId: 'ch3' },
  { id: 'powerlessness', label: 'Powerlessness (could not stop)', chapterId: 'ch4' },
  { id: 'failed_stops', label: 'Failed attempts to stop', chapterId: 'ch4' },
  { id: 'unmanageability', label: 'Unmanageability', chapterId: 'ch5' },
  { id: 'relationships_impact', label: 'Impact on relationships', chapterId: 'ch5' },
  { id: 'consequences', label: 'Consequences (work, legal, health)', chapterId: 'ch5' },
  { id: 'bottom', label: 'Bottom / turning point', chapterId: 'ch6' },
  { id: 'recovery_start', label: 'How recovery began', chapterId: 'ch6' },
  { id: 'closing', label: 'Closing (name, fellowship)', chapterId: 'ch7' },
];

export const STEP1_CHAPTERS = [
  { id: 'ch1', title: 'Introduction', optional: false },
  { id: 'ch2', title: 'Family & early life', optional: false },
  { id: 'ch3', title: 'How addiction developed', optional: false },
  { id: 'ch4', title: 'Powerlessness', optional: false },
  { id: 'ch5', title: 'Unmanageability', optional: false },
  { id: 'ch6', title: 'Hitting bottom & recovery', optional: false },
  { id: 'ch7', title: 'Closing', optional: false },
] as const;

export type Step1ChapterId = (typeof STEP1_CHAPTERS)[number]['id'];
